import React from "react";
import { Phone } from "lucide-react";

// TODO: uzupełnić przez klienta
const PHONE_TEL = "+48669255184";

export const MobileStickyCta = () => (
  <a
    href={`tel:${PHONE_TEL}`}
    data-testid="mobile-sticky-call"
    className="md:hidden fixed bottom-4 right-4 z-40 inline-flex items-center gap-2 bg-mustard hover:bg-mustard-dark text-white font-semibold px-5 py-3.5 rounded-full shadow-lg shadow-forest/20"
    aria-label="Zadzwoń teraz"
  >
    <Phone size={18} strokeWidth={2.4} />
    Zadzwoń
  </a>
);

export default MobileStickyCta;
